<template>
  <div class="month-picker__container" :class="`month-picker--${variant}`">
    <div class="row px-0 mx-0">
      <div class="text-center col-md-12 pb-1 pt-1" v-if="showYear">
        <button
          @click="changeYear(-1)"
          v-bind:disabled="!hasPreviousYear"
          class="btn btn-outline-secondary btn-sm mr-1"
        >
          <font-awesome-icon icon="angle-left" />
        </button>
        <b-form-select
          v-model="year"
          :options="yearOptions"
          size="sm"
          style="text-align-last: center;width: 100px; "
        />
        <button
          @click="changeYear(+1)"
          v-bind:disabled="!hasNextYear"
          class="btn btn-outline-secondary btn-sm ml-1"
        >
          <font-awesome-icon icon="angle-right" />
        </button>
      </div>
    </div>
    <div class="month-picker">
      <div
        v-for="(month, i) in monthsByLang"
        :key="month"
        :class="{
          clearable: clearable,
          selected: currentMonth === month
        }"
        class="month-picker__month"
        @click="selectMonth(i, true)"
      >
        {{ month }}
      </div>
    </div>
  </div>
</template>

<script>
import monthPicker from './month-picker'

export default {
  name: 'month-picker',
  mixins: [monthPicker],
  data: () => ({
    firstYear: 2010,
    currentYear: new Date().getFullYear(),
    currentMonthIndex: null,
    year: new Date().getFullYear(),
    yearOptions: []
  }),
  computed: {
    currentMonth: function () {
      if (this.currentMonthIndex !== null) {
        return this.monthsByLang[this.currentMonthIndex]
      }
      return 0
    },
    hasNextYear: function () {
      return this.year !== this.currentYear
    },
    hasPreviousYear: function () {
      return this.year !== (this.firstYear)
    },
    date: function () {
      const month = this.monthsByLang.indexOf(this.currentMonth) + 1
      const date = new Date(`${this.year}/${month}/01`)
      const year = date.getFullYear()

      return {
        from: date,
        to: new Date(year, month, 1),
        month: this.monthsByLang[month - 1],
        monthIndex: month,
        year: year
      }
    }
  },
  watch: {
    defaultMonth (newVal) {
      this.currentMonthIndex = newVal
    },
    defaultYear (newVal) {
      if (newVal <= this.currentYear) {
        this.year = newVal
      } else {
        this.year = this.currentYear
      }
    }
  },
  mounted () {
    let yearStored = this.year
    if (isNaN(yearStored) || (yearStored > this.currentYear && yearStored < this.firstYear)) {
      yearStored = this.currentYear
    }
    const yearInfoList = []
    for (let year = this.currentYear; year >= this.firstYear; year--) {
      yearInfoList.push({ value: year, text: year + '' })
    }
    this.yearOptions = yearInfoList
    if (this.defaultMonth) {
      this.selectMonth(this.defaultMonth - 1)
    } else if (!this.noDefault) {
      this.selectMonth(0)
    }

    if (this.defaultYear && this.defaultYear <= this.currentYear) {
      this.year = this.defaultYear
    } else {
      this.year = this.currentYear
    }
  },
  methods: {
    onChange () {
      if (!Number.parseInt(this.year)) {
        this.year = this.defaultYear || new Date().getFullYear()
      }

      this.$emit('change', this.date)
    },
    selectMonth (index, input = false) {
      const isAlreadySelected = this.currentMonthIndex === index
      if (this.clearable && isAlreadySelected) {
        this.currentMonthIndex = null
        this.$emit('clear')
        return
      }

      if (this.isAlreadySelected) {
        return
      }

      this.currentMonthIndex = index
      this.onChange()
      if (input) {
        this.$emit('input', this.date)
      }
    },
    changeYear (value) {
      this.year += value
      this.onChange()
      this.$emit('change-year', this.year)
    }
  }
}
</script>

<style>
.month-picker__container {
  position: relative;
  border: 1px solid #dddddd;
  border-radius: 5px;
}

.month-picker {
  box-sizing: border-box;
  flex: 1;
  width: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  font-family: sans-serif;
  border-radius: 5px;
  overflow: hidden;
}

.month-picker__year p {
  width: 100%;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 1.2em;
}

.month-picker__year input {
  padding: 0;
  font-weight: 600;
  border-radius: 5px 5px 0 0;
  outline: none;
  border: none;
  font-size: 0.875rem;
  width: auto;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  height: 3em;
  position: relative;
  z-index: 1;
}

.month-picker__year input:focus {
  border: 1px solid #55b0f2;
}

.month-picker__year div,
.month-picker__year button,
.month-picker__year p {
  text-align: center;
  flex: 1;
}

.month-picker__year button {
  background-color: #ffffff;
  position: absolute;
  width: 2em;
  font-size: 1.5em;
  border-radius: 5px;
  outline: none;
  border: 0;
  top: 10px;
  border: 1px solid #e8e8e8;
  z-index: 2;
  color: #686868;
}

.month-picker__year button:hover {
  background-color: rgba(0, 0, 0, 0.025);
}

.month-picker__year button:active {
  background-color: rgba(0, 0, 0, 0.04);
}

.month-picker__year button:first-child {
  left: 10px;
}

.month-picker__year button:last-child {
  right: 10px;
}

.month-picker__month {
  flex-basis: calc(33.333%);
  padding: 0.75em 0.25em;
  cursor: pointer;
  text-align: center;
  font-size: 0.875em;
  border: 1px solid rgba(245, 245, 245, 0.75);
  transition: all 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
  background-color: #fefefe;
}

.month-picker__month.selected {
  background-color: #55b0f2;
  color: #ffffff;
  border-radius: 5px;
  box-shadow: inset 0 0 3px #3490d2, 0px 2px 5px rgba(85, 176, 242, 0.2);
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}

.month-picker .month-picker__month:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

/* Dark theme */
.month-picker--dark {
  background-color: #5f5f5f;
}

.month-picker--dark .month-picker__year p,
.month-picker--dark .month-picker__year input {
  color: #ebebeb;
}

.month-picker--dark .month-picker__year input {
  background-color: #5f5f5f;
}

.month-picker--dark .month-picker__year button {
  background-color: #505050;
  color: #c9c9c9;
  border-color: #1e1e1e;
}

.month-picker--dark .month-picker__year button:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

.month-picker--dark .month-picker__year button:active {
  background-color: rgba(0, 0, 0, 0.6);
}

.month-picker--dark .month-picker__month {
  background-color: #2f2f30;
  border-color: rgba(245, 245, 245, 0.15);
  color: #c9c9c9;
}

.month-picker--dark .month-picker__month.selected {
  background-color: #505050;
  box-shadow: inset 0 0 3px #505050, 0px 2px 5px #505050;
  color: #ffffff;
  border-color: #1e1e1e;
}

.month-picker--dark .month-picker__month:hover {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
  z-index: 10;
}

@media only screen and (max-width: 768px) {
  .month-picker__container {
    width: 100%;
  }
}
</style>
